import { get, post, remove } from "./base";

export function getCOProjects() {
  return get("/api/completion_optimizer/projects/settings/", {}, {}).then(
    (res) => res.data
  );
}

export function getCOProjectSettings(projectId, backupId) {
  return get(
    `/api/completion_optimizer/projects/edit/${projectId}/${backupId}/`,
    {},
    {}
  ).then((res) => {
    console.log(res.data);
    return res.data;
  });
}

export function upsertProjectSettings(data) {
  // Log data just before API call
  console.log("Data being sent to API:", data);
  console.log("PVT gas data in API call:", data.PVT?.gas);

  return post(
    `/api/completion_optimizer/projects/settings/create_or_update/`,
    data,
    {},
    {}
  );
}

export function runCOProject(data) {
  return post(`/api/completion_optimizer/run/create/`, data, {}, {});
}

export function getProjectNumOfStages(projectId) {
  return get(
    `/api/completion_optimizer/run/project_stages/${projectId}/`,
    {},
    {}
  ).then((res) => res.data);
}

export function getStagePlotResult(projectId, rateNo, stageNo) {
  return get(
    `/api/completion_optimizer/run/rate_${rateNo}/${projectId}/${stageNo}/`,
    {},
    {}
  ).then((res) => res.data);
}

export function getProjectListWithResults() {
  return get("/api/completion_optimizer/run/results/", {}, {}).then((res) => {
    console.log(res);
    return res.data;
  });
}

export function deleteCOProject(projectId) {
  return remove(
    `/api/completion_optimizer/projects/settings/${projectId}/delete/`,
    {},
    {},
    {}
  ).then((res) => res.data);
}

export function getWellPlotResult(projectId) {
  return get(
    `/api/completion_optimizer/run/well/rates/${projectId}/`,
    {},
    {}
  ).then((res) => res.data);
}

export function getStage3dBase(projectId, stageNumber) {
  return get(
    `/api/completion_optimizer/run/files/${projectId}/${stageNumber}/base/`,
    {},
    {}
  ).then((res) => res.data);
}

export function getStage3dCommodityFile(
  projectId,
  stageNumber,
  commodity,
  model,
  date
) {
  return get(
    `/api/completion_optimizer/run/files/${projectId}/${stageNumber}/${commodity.toLowerCase()}/${model}/${date}/`,
    {},
    {}
  ).then((res) => res.data);
}

export function getStage3dPressure(projectId, stageNumber) {
  return get(
    `/api/completion_optimizer/run/files/${projectId}/${stageNumber}/pressure/`,
    {},
    {}
  ).then((res) => res.data);
}

export function getStage3dGas(projectId, stageNumber) {
  return get(
    `/api/completion_optimizer/run/files/${projectId}/${stageNumber}/sgas/`,
    {},
    {}
  ).then((res) => res.data);
}

export function getStage3dWater(projectId, stageNumber) {
  return get(
    `/api/completion_optimizer/run/files/${projectId}/${stageNumber}/swat/`,
    {},
    {}
  ).then((res) => res.data);
}

export function getWellRates(projectId, model) {
  return get(
    `/api/completion_optimizer/run/well/rates/${projectId}/${model}/`,
    {},
    {}
  ).then((res) => res.data);
}

export function getWellCumulatives(projectId, model) {
  return get(
    `/api/completion_optimizer/run/well/cumulative/${projectId}/${model}/`,
    {},
    {}
  ).then((res) => res.data);
}

export function getStageRates(projectId, stage, model) {
  return get(
    `/api/completion_optimizer/run/rate_0/${projectId}/${stage}/${model}/`,
    {},
    {}
  ).then((res) => ({
    ...res.data,
    stage,
  }));
}

export function getStageCumulatives(projectId, stage, model) {
  return get(
    `/api/completion_optimizer/run/rate_1/${projectId}/${stage}/${model}/`,
    {},
    {}
  ).then((res) => ({
    ...res.data,
    stage,
  }));
}

export function get3dStageTree(projectId, model, stageNo) {
  return get(
    `/api/completion_optimizer/run/3d/${projectId}/${model}/tree/${stageNo}/`,
    {},
    {}
  ).then((res) => res.data);
}

export function getRunProgress(projectId, model) {
  return get(
    `/api/completion_optimizer/run/progress/${projectId}/${model}/`,
    {},
    {}
  ).then((res) => res.data);
}

export function getCustomizedModels() {
  return get(
    "/api/completion_optimizer/projects/customized/models/",
    {},
    {}
  ).then((res) => res.data);
}

export function getKIcReferences() {
  return get(
    "/api/completion_optimizer/projects/customized/kic_references/",
    {},
    {}
  ).then((res) => res.data);
}

export function getReferenceList(group, type) {
  return get(
    `/api/completion_optimizer/projects/references/${group}/${type}/`,
    {},
    {}
  ).then((res) => res.data);
}

export function getReferenceData(group, type, id) {
  return get(
    `/api/completion_optimizer/projects/references/${group}/${type}/${id}/`,
    {},
    {}
  ).then((res) => res.data);
}

export function getFractureToughness(data) {
  return post(
    "/api/completion_optimizer/projects/get-fracture-toughness/",
    data,
    {},
    {}
  ).then((res) => res.data);
}
